declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      portalUrl?: string;
    };
  }
}

export const getEnvironmentVar = (code: string): string | undefined => {
  if (
    code === 'REACT_APP_PORTAL_URL' &&
    typeof window !== 'undefined' &&
    window.__RUNTIME_CONFIG__ &&
    window.__RUNTIME_CONFIG__.portalUrl
  ) {
    return window.__RUNTIME_CONFIG__.portalUrl;
  }

  return process.env[code] || '';
};
